import { isAxiosError } from 'axios'

import { deleteEnvelope } from '../delete-envelope'

export const REMOVE_ENVELOPE_QUERY_KEYS = [
  'envelopes',
  'envelope',
  'vault-items',
]

const isNotFound = (error: unknown): boolean =>
  isAxiosError(error) && error.response?.status === 404

export async function removeEnvelope(envelopeId: string): Promise<void> {
  try {
    await deleteEnvelope(envelopeId)
  } catch (error) {
    if (!isNotFound(error)) throw error
  }
}
